export enum BYME_MESSAGES {
    LOGIN = "Login",
    LOGIN_REQUIRED = "LoginRequired",
    LOGIN_SUCCEEDED = "LoginSucceeded",
    LOGIN_FAILED = "LoginFailed",
    SET_UP_SETTINGS = "SetUpSettings",
    AUTHENTICATION_REQUIRED = "AuthenticationRequired",
    AUTHENTICATION = "Authentication",
    AUTHENTICATION_FAILED = "AuthenticationFailed",
    AUTHENTICATION_SUCCEEDED = "AuthenticationSucceeded",
    CHANGE_NEED_MAPPING = "ChangeNeedMapping",
    CLOSE_APP = "CloseApp",
    COMPOSER_PRICE_INFO_BUTTON_CLICKED = "ComposerPriceInfoButtonClicked",
    PRICE_INFO_BUTTON_CLICKED = "PriceInfoButtonClicked",
    SAVE_REQUESTED = "SaveRequested",
    SAVE_SUCCEEDED = "SaveSucceeded",
    PLANS_2D_STOP = "Plans2DStop",
    COMPUTE_2D_PLANS = "Compute2DPlans",
    PRINT_BUTTON_CLICKED = "PrintButtonClicked",
    SHARE_PROJECT_BOM = "ShareProjectBOM",
    PRODUCT_LIST_WITH_BOM = "ProductListWithBOM",
    PRODUCT_LIST_WITH_BOM_FORMATTED_PRICES = "ProductListWithBOM-FormattedPrices",
    PROJECT_SAVED_REQUEST_FOR_PRINT = "ProjectSavedRequestForPrint",
    READY = "Ready",
    SHARE_PROJECT = "ShareProject",
    SNAPSHOT_GENERATED = "SnapshotGenerated",
    SNAPSHOT_REQUESTED = "SnapshotRequested",
    SPECIAL_PRODUCT_INFO_REQUESTED = "SpecialProductInfoRequested",
    TOKEN_EXPIRED = "TokenExpired",
    TOKEN_REFRESHED = "TokenRefreshed",
    WALL_EDGE_STRIP_PRICE_INFO_BUTTON_CLICKED = "WallEdgeStripPriceInfoButtonClicked",
    WALL_PANEL_PRICE_INFO_BUTTON_CLICKED = "WallPanelPriceInfoButtonClicked",
    WORKTOP_PRICE_INFO_BUTTON_CLICKED = "WorktopPriceInfoButtonClicked",
    WORKTOP_TYPES_INTO_REQUESTED = "WorktopTypesInfoRequested"
}